export * from './user-product-config.model';


// WEBPACK FOOTER //
// ./src/app/data/models/master/op/index.ts